import PropTypes from 'prop-types'
import { IconButton, InputAdornment, TextField } from '@mui/material'

import { ReactComponent as MagnifyingGlass } from '../../../assets/icons/magnifying-glass.svg'
import { ReactComponent as X } from '../../../assets/icons/x.svg'

const SearchField = ({
  id,
  className,
  sx,
  value,
  onChange,
  onClear,
  helperText,
  placeholder,
}) => {
  return (
    <TextField
      type="text"
      name={id}
      id={id}
      className={className}
      sx={sx}
      onChange={onChange}
      value={value}
      helperText={helperText}
      placeholder={placeholder}
      InputProps={{
        endAdornment: (
          <InputAdornment position="end">
            {value !== '' && (
              <IconButton onClick={onClear} aria-label="clear" size="large">
                <X />
              </IconButton>
            )}
            <IconButton aria-label="search" size="large" disabled>
              <MagnifyingGlass />
            </IconButton>
          </InputAdornment>
        ),
      }}
    />
  )
}

SearchField.propTypes = {
  id: PropTypes.string,
  className: PropTypes.string,
  sx: PropTypes.object,
  value: PropTypes.string,
  helperText: PropTypes.string,
  placeholder: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  onClear: PropTypes.func,
}

export default SearchField
